module.exports = __webpack_public_path__ + "img/cookie.1acee06f.svg";